import React from 'react';
import { IconButton } from '@fluentui/react';
import { fetchCopilotAccessToken, getConversationID, getConversationMessages, postUserPromptText, uploadFilesInBatch } from './CopilotIntegration/CopilotFunctions';
import { Icon, IOverflowSetItemProps, IPersonaSharedProps, OverflowSet, Spinner } from 'office-ui-fabric-react';
import { isStringValidated } from '../Global/constants';
import moment from 'moment';
import { getAIAgentData, postAIAgentData } from '../UtilityFunctions/CommonFunction';
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Message } from 'yup';
import { useGetSet } from 'react-use';


let CurrentUserChats = []
let Currentmessages = [];
const CopilotChatbot = ({ setChatbot }) => {
    const messagesEndRef = React.useRef<any>(null);
    const directLineEndpoint = "https://directline.botframework.com/v3/directline";
    const CurrentUser = JSON.parse(localStorage.getItem("CurrentUser") || "{}")
    const CopilotLogo: any = require('../../../../assets/CopilotLogo.png');
    const CopilotUrl = JSON.parse(localStorage.getItem("Copilot") || "{}")?.CopilotUrl
    const [messages, setMessages] = useGetSet<any>([]);
    const [userInput, setUserInput] = React.useState("");
    const [isTyping, setIsTyping] = React.useState(false);
    const [directLineToken, setDirectLineToken] = React.useState<string | null>(null);
    const [conversationId, setConversationId] = React.useState<string | null>(null);
    const [watermark, setWatermark] = React.useState<string | null>(null);
    const [showChat, setShowChat] = React.useState({ Main: false, Body: true })
    const [chatSessionID, setChatSessionID] = useGetSet("");
    const [recentChatId, setRecentChatId] = useGetSet("");
    const [matchedIndexes, setMatchedIndexes] = React.useState<number[]>([]);
    const [SearchButton, setSearchButton] = React.useState(false);
    const [TextSearch, setTextSearch] = React.useState("");
    const [attachments, setAttachments] = React.useState<{ file: File | null; name: string }[]>([]);
    const [loading, setLoading] = React.useState(false)
    const [percent, setPercent] = React.useState(0)
    const [copiedIndex, setCopiedIndex] = React.useState<number | null>(null);

    React.useEffect(() => {
        scrollToBottom();
    }, [messages()]);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    React.useEffect(() => {
        if (!directLineToken) return;

        (async () => {
            const conversationId = await getConversationID(directLineToken)
            setConversationId(conversationId);
        })();

    }, [directLineToken]);

    React.useEffect(() => {
        if (!conversationId || !directLineToken) return;

        fetchMessages();
    }, [conversationId, directLineToken, watermark]);
    React.useEffect(() => {
        (async () => {
            try {
                const accessToken = await fetchCopilotAccessToken(CopilotUrl);
                setDirectLineToken(accessToken);
            } catch (error) {
                console.error("Error extracting document text:", error);
            }
        })();
    }, []);
    const fetchMessages = async () => {
        try {
            const botConversation = await getConversationMessages(directLineToken, conversationId, watermark)
            const botMessages = botConversation?.activities.filter(
                (activity: any) => activity.from.id !== "user" && activity.text?.trim()
            );
            const botResponse = botConversation?.activities.filter(
                (activity) =>
                    activity.from.id !== "user" && activity.attachments?.length
            );
            const oauthAttachment = botResponse[0]?.attachments?.find(
                (a) => a.contentType === "application/vnd.microsoft.card.oauth"
            );

            if (oauthAttachment) {
                const loginUrl = oauthAttachment.content.buttons[0].value;
                window.open(loginUrl, "_blank");
            }

            if (botMessages.length > 0) {
                const formatted = botMessages?.map((msg) => {
                    const cleanedText = msg?.text?.replace(/[*#]/g, '');
                    return {
                        from: "Copilot",
                        name: CopilotLogo,
                        text: cleanedText ?? "[Bot sent a card or non-text message]",
                        time: msg?.timestamp,
                    }
                });

                setMessages((prev) => [...prev, ...formatted]);
                Currentmessages = [...Currentmessages, ...formatted]
                setIsTyping(false);
                setWatermark(botConversation?.watermark);
                return true;
            }

            setWatermark(botConversation?.watermark);
            return false;
        } catch (error) {
            console.error("Error fetching messages:", error);
            return false;
        }
    };
    const sendMessage = async () => {
        if (!userInput.trim() || (!conversationId)) return;
        Currentmessages = [
            ...Currentmessages,
            {
                from: "user",
                name: (<div className='You'>You</div>),
                text: userInput,
                time: new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                }),
                Attachments: attachments,
            },
        ];
        setMessages((prev) => [
            ...prev,
            {
                from: "user",
                name: (<div className='You'>You</div>),
                text: userInput,
                time: new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                }),
                Attachments: attachments,
            },
        ]);
        setAttachments([]);
        setUserInput("");
        setIsTyping(true);
        await closeChat('Continue')
        const sendMessage = await postUserPromptText(userInput, conversationId, directLineToken)
        if (sendMessage) {
            renderBotMessages()
        }
    };


    const renderBotMessages = async () => {
        const interval = setInterval(async () => {
            const hasMessages = await fetchMessages();
            if (hasMessages) {
                clearInterval(interval);
                await closeChat('Continue')
            }
        }, 2000);
    };

    const onRenderOverflowButton = (overflowItems: any[] | undefined): JSX.Element => {
        return (
            <IconButton
                title="More options"
                menuIconProps={{ iconName: 'MoreVertical' }}
                menuProps={{ items: overflowItems!, className: 'menuPropsWidth' }}
                styles={{ root: { color: "white !important" } }}
                className="icon-button-no-hover"
            />
        );
    };
    const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
        return (
            <div>{item.name}</div>
        );
    };

    const renderAdaptiveCard = (attachment: any) => {
        if (attachment.contentType === 'application/vnd.microsoft.card.adaptive') {
            const card = attachment.content;

            const handleActionSubmit = async (actionData: any) => {
                if (!conversationId || !directLineToken) return;

                const message: Message = {
                    type: 'message',
                    from: 'user',
                    text: actionData.action, // Send the action (Retry/Cancel) as text
                    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                };

                setMessages((prev) => [...prev, message]);
                setIsTyping(true);

                try {
                    await axios.post(
                        `${directLineEndpoint}/conversations/${conversationId}/activities`,
                        {
                            type: 'message',
                            from: { id: 'user', name: 'You' },
                            text: actionData.action,
                        },
                        { headers: { Authorization: `Bearer ${directLineToken}` } }
                    );
                } catch (error) {
                    console.error('Error sending action:', error);
                }
            };

            const renderElement = (element: any, index: any) => {
                if (element.type === 'TextBlock') {
                    // Handle markdown links in text
                    const processedText = element.text.replace(/\[([^\]]+)\]\(([^)]+)\)/g,
                        '<a href="$2" target="_blank" rel="noopener noreferrer" style="color: #0078d4; text-decoration: none;">$1</a>'
                    );

                    return (
                        <div key={index} style={{
                            fontSize: element.size === 'Large' ? '18px' : '14px',
                            fontWeight: element.weight === 'Bolder' ? 'bold' : 'normal',
                            marginBottom: '8px',
                            color: '#333',
                            lineHeight: '1.4'
                        }} dangerouslySetInnerHTML={{ __html: processedText }} />
                    );
                }

                if (element.type === 'ColumnSet') {
                    return (
                        <div key={index} style={{
                            display: 'flex',
                            gap: '8px',
                            marginTop: '16px'
                        }}>
                            {element.columns?.map((column: any, colIndex: number) => {
                                if (column?.items?.length) {
                                    return (
                                        <div key={colIndex} style={{
                                            // flex: column.width === '40' ? '2' : '1',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: column.width === '40' ? 'flex-start' : 'center'
                                        }}>
                                            {column.items?.map((item: any, itemIndex: number) =>
                                                renderElement(item, `${colIndex}-${itemIndex}`)
                                            )}
                                        </div>
                                    )
                                }
                            })}

                        </div>
                    );
                }

                if (element.type === 'ActionSet') {
                    return (
                        <div key={index} style={{
                            display: 'flex',
                            gap: '8px',
                            justifyContent: 'center'
                        }}>
                            {element.actions?.map((action: any, actionIndex: number) => {
                                if (action.type === 'Action.Submit') {
                                    return (
                                        <button
                                            key={actionIndex}
                                            onClick={() => handleActionSubmit(action.data)}
                                            style={{
                                                backgroundColor: action.style === 'positive' ? '#0078d4' : '#f3f2f1',
                                                color: action.style === 'positive' ? 'white' : '#323130',
                                                border: action.style === 'positive' ? 'none' : '1px solid #d2d0ce',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                minWidth: '80px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (action.style === 'positive') {
                                                    e.currentTarget.style.backgroundColor = '#106ebe';
                                                } else {
                                                    e.currentTarget.style.backgroundColor = '#edebe9';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (action.style === 'positive') {
                                                    e.currentTarget.style.backgroundColor = '#0078d4';
                                                } else {
                                                    e.currentTarget.style.backgroundColor = '#f3f2f1';
                                                }
                                            }}
                                        >
                                            {action.title}
                                        </button>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    );
                }

                return null;
            };

            return (
                <div style={{
                    border: '1px solid #e1e1e1',
                    borderRadius: '8px',
                    padding: '16px',
                    margin: '8px 0',
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    maxWidth: '100%'
                }}>
                    {card.body?.map((element: any, index: number) => renderElement(element, index))}
                </div>
            );
        }

        return null;
    };

    const BackToChat = () => {
        setShowChat({ Main: false, Body: true })
        setChatSessionID(recentChatId)
    }
    const onhandleChange = (_ev): void => {
        let textsearch = _ev.target.value;
        setTextSearch(textsearch);
    };

    const onSearch = () => {
        const filteredMessage = messages()
            .map((msg, index) => ({ ...msg, index }))
            .filter((msg) =>
                msg?.text.toLowerCase().includes(TextSearch.toLowerCase())
            );

        if (filteredMessage.length > 0) {
            setMatchedIndexes(filteredMessage.map((m) => m.index));

            const lastMatch = filteredMessage[filteredMessage.length - 1];
            setTimeout(() => {
                const element = document.getElementById(`msg-${lastMatch.index}`);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 100);
        } else {
            setMatchedIndexes([]);
        }
    };
    const highlightText = (text: string, search: string, highlight: boolean) => {
        if (!highlight || !search) return text;
        const regex = new RegExp(`(${search})`, "gi");
        const parts = text.split(regex);

        return parts.map((part, i) =>
            part.toLowerCase() === search.toLowerCase() ? (
                <mark key={i} style={{ backgroundColor: "yellow" }}>
                    {part}
                </mark>
            ) : (
                part
            )
        );
    };

    const RecentChat = (chat) => {
        setShowChat({ Main: false, Body: true })
        setChatSessionID(chat.SessionID)
        setRecentChatId(chat.SessionID)
        if (chat?.ParsedMessages?.length) {
            const formatedMessage = chat?.ParsedMessages.map((msg) => {
                if (msg.from === "user") {
                    return {
                        ...msg,
                        name:
                            (<div className='You'>You</div>)
                    };
                }

                return msg;
            });
            setMessages(formatedMessage)
            scrollToBottom()
        }
    }
    const closeChat = async (c) => {
        let safeMessages;
        if (messages()?.length) {
            safeMessages = messages().map(msg => ({
                ...msg,
                name: typeof msg.name === 'object'
                    ? 'You'
                    : msg?.name
            }));

            const finalTemplate = {
                SessionID: chatSessionID() ? chatSessionID() : uuid() || '',
                UserEmail: CurrentUser?.currentUserEmail || '',
                UserName: CurrentUser?.currentUserName || '',
                UserGUID: CurrentUser?.GUID || '',
                Messages: JSON.stringify(safeMessages),
            }
            setChatSessionID(finalTemplate?.SessionID)
            setRecentChatId(finalTemplate?.SessionID)
            await postAIAgentData(finalTemplate)
            if (attachments?.length) {
                await uploadFilesInBatch(attachments, finalTemplate?.SessionID);
                setAttachments([])
            }
            if (c !== 'Like' && c !== 'Continue' && c !== 'NewChat' && c !== 'Recents') {
                setChatbot()
            } else if (c === 'NewChat') {
                setMessages([]);
                setChatSessionID('');
                setRecentChatId('');
                setShowChat({ Main: false, Body: true });
            }
        } else if (c === 'NewConversation') {
            setChatSessionID('');
            setRecentChatId('');
            setShowChat({ Main: false, Body: true });
        } else if (c === '') {
            setChatbot(false)
        }
    }

    const getCurrentUserChats = async () => {
        CurrentUserChats = []
        const AIAgentData = await getAIAgentData(CurrentUser?.GUID, '');
        AIAgentData.map((i) => {
            CurrentUserChats.push({
                SessionID: i.SessionID,
                Messages: i.Messages
            })
        })
        setChatSessionID("")
        setShowChat({ Main: true, Body: false })
    }
    const addAttachment = (files: FileList) => {
        const newFiles = Array.from(files).map((file) => ({
            file,
            name: file.name,
        }));
        setAttachments((prev) => [...prev, ...newFiles]);
    };

    const removeAttachment = (index: number) => {
        setAttachments((prev) => prev.filter((_, i) => i !== index));
    };

    const copyToClipboard = (text: string, index: number) => {
        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);

            textarea.focus();
            textarea.select();

            const successful = document.execCommand("copy");
            document.body.removeChild(textarea);

            if (successful) {
                setCopiedIndex(index);
                setTimeout(() => setCopiedIndex(null), 2000);
            } else {
                console.error("Copy command failed");
            }
        } catch (err) {
            console.error("Fallback: Unable to copy", err);
        }
    };

    const LikeMessage = (condition, index) => {
        const user = CurrentUser?.loginName;
        if (!messages()[index]) return;

        const otherCondition = condition === "Like" ? "Dislike" : "Like";

        messages()[index][condition] = messages()[index][condition] || [];
        messages()[index][otherCondition] = messages()[index][otherCondition] || [];

        if (!messages()[index][condition].includes(user)) {
            messages()[index][condition].push(user);
        }

        messages()[index][otherCondition] = messages()[index][otherCondition].filter(
            (u) => u !== user
        );
        setMessages([...messages()]);
        closeChat('Like')
    };

    return (
        <div 
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: 'space-between',
                height: 'calc(100vh - 58px)',
                padding: '4px'
            }}>
            <div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "column",
                        fontSize: "12px",
                        padding: "5px 0px",
                        backgroundColor: '#106EBE'
                    }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}>
                        <div
                            style={{
                                padding: "0px 10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "4px",
                            }}>
                            <p
                                style={{
                                    margin: 0,
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    color: 'white'
                                }}>
                                {/* CLM365 with Copilot AI */}
                                Rivo
                            </p>
                            <img src={CopilotLogo} alt="Logo" style={{ maxWidth: "25px" }} />
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div>
                                <OverflowSet
                                    className="OverFlowSetIcon"
                                    aria-label="Vertical Example"
                                    vertical={true}
                                    overflowItems={[
                                        {
                                            key: 'RecentChats',
                                            name: "Recent Chats",
                                            iconName: 'Recent',
                                            onClick: () => {
                                                getCurrentUserChats()
                                            }
                                        },
                                    ]}
                                    onRenderOverflowButton={onRenderOverflowButton}
                                    onRenderItem={onRenderItem} />
                            </div>
                            <div className={'AIChatbotIcons'}
                                onClick={() => {
                                    closeChat("NewChat");
                                }}
                            >
                                <Icon
                                    title={"New Chat"}
                                    iconName="PageEdit"
                                    styles={{ root: { color: "white !important" } }}
                                />
                            </div>
                            <div >
                                <IconButton
                                    onClick={() => closeChat("")}
                                    iconProps={{ iconName: 'Cancel', styles: { root: { color: 'white !important', fontSize: 'small' } } }} title="Close"
                                    className="icon-button-no-hover"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <p style={{ margin: 0, paddingLeft: "10px", fontSize: '8px', color: 'white' }} title={'Interact with the AI to get information about this contract instantly.'}>
                            {'Interact with the AI to get information about this contract instantly.'}
                        </p>
                        {messages()?.length > 0 ? (
                            <Icon
                                iconName="Search"
                                onClick={() => {
                                    setSearchButton(!SearchButton);
                                    setMatchedIndexes([]);
                                }}
                                style={{
                                    position: "fixed",
                                    top: "54px",
                                    right: "24px",
                                    cursor: "pointer",
                                    color: "white !important",
                                    fontSize: "12px",
                                }}
                                styles={{
                                    root: {
                                        color: "white !important",
                                        fontWeight: "1000",
                                        fontSize: "18px",
                                    },
                                }}
                            />
                        ) : null}
                    </div>
                    {SearchButton ? (
                        <div style={{ display: 'contents' }}>
                            <input
                                placeholder={"Search"}
                                onChange={(_ev) => onhandleChange(_ev)}
                                className={"SearchInput"}
                                onKeyDown={(e) => {
                                    if (
                                        !isTyping &&
                                        e.key === "Enter" &&
                                        TextSearch.trim() !== ""
                                    ) {
                                        onSearch();
                                    }
                                }}
                            />
                        </div>
                    ) : null}
                </div>
                {/* height: `calc(100vh - ${attachments.length > 0 ? 218 + (attachments.length - 1) * 24 : 180}px)` */}
                <div style={{ display: messages()?.length || (showChat.Main && CurrentUserChats?.length > 0) ? '' : 'flex' }} className='chat-container'>
                    {showChat.Main && <div className={'RecentChatsMain'}>
                        <div className={'BackRecentButton'}>
                            <Icon
                                iconName="Back"
                                title="Back"
                                aria-hidden="true"
                                onClick={BackToChat}
                                styles={{ root: { height: 19, minWidth: 12, fontSize: 12 } }}

                            />
                            <label className={'Recentheading'}>{CurrentUserChats?.length ? 'Recent' : 'No recent chat available'}</label>
                        </div>
                        {[...CurrentUserChats]
                            ?.map((chat) => {
                                const Messages = isStringValidated(chat?.Messages)
                                    ? JSON.parse(chat?.Messages)
                                    : [];
                                return {
                                    ...chat,
                                    ParsedMessages: Messages,
                                    LatestTime: new Date(Messages[1]?.time || Messages[0]?.time || 0),
                                };
                            })
                            ?.sort((a, b) => b.LatestTime - a.LatestTime)
                            ?.map((chat, index) => {
                                const Messages = chat.ParsedMessages;
                                const thirdLast = Messages[Messages?.length - 2];
                                const secondLast = Messages[Messages?.length - 1];
                                if (Messages[0]) {
                                    return (
                                        <div className={'messageitem'} key={index}
                                            onClick={() => RecentChat(chat)}>
                                            <div className={'messagecontent'}>
                                                <div className={'toprow'}>
                                                    <span className={'name'}>{thirdLast?.text || "Unknown"}</span>
                                                    <span className={'date'}>
                                                        {moment(Messages[1]?.time || new Date()).format("DD/MM/YYYY")}
                                                    </span>
                                                </div>
                                                <div className={'AIResp'}>
                                                    {secondLast?.text || "No message available"}
                                                </div>
                                            </div>
                                            <div className={'arrow'}>›</div>
                                            {index !== CurrentUserChats?.length - 1 && <hr />}
                                        </div>
                                    );
                                }
                                return null;
                            })}
                    </div>}
                    {showChat.Body && <div >
                        {messages().length == 0 && <div style={{
                            fontSize: "16px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            height: "100%",
                            width: "100%"
                        }}>
                            <div>Hi {CurrentUser?.currentUserName}. What's new?</div>
                            <div style={{ fontSize: '10px' }}>Ask me anything about this contract.</div>
                        </div>}
                        {!loading && <div style={{ paddingLeft: '5px' }}>
                            {messages()?.map((msg, index) => {
                                const isUser = msg?.from === "user";
                                const timeFormatted =
                                    msg?.time && msg?.from !== "user"
                                        ? new Date(msg?.time).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })
                                        : msg?.time;

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            justifyContent: isUser ? "flex-end" : "flex-start",
                                            marginBottom: "20px",  //8
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                maxWidth: isUser ? "52%" : "86%",
                                                gap: "3px",
                                            }}
                                        >
                                            {isUser ? (
                                                msg?.name
                                            ) : (
                                                <div className='Rivo'> Rivo </div>
                                            )}
                                            <div>
                                                {isStringValidated(msg?.text) ? (
                                                    <div className='msgContainer'
                                                        id={`msg-${index}`}>
                                                        {highlightText(
                                                            msg.text,
                                                            TextSearch,
                                                            matchedIndexes.includes(index)
                                                        )}
                                                        {/* {msg?.text} */}
                                                    </div>
                                                ) : null}
                                                {msg.attachments?.map((attachment: any, attachIndex: number) => (
                                                    <div key={attachIndex}>
                                                        {renderAdaptiveCard(attachment)}
                                                    </div>
                                                ))}
                                                {!isUser && <div>
                                                    {msg?.Source && (
                                                        <div className="SourceMain">
                                                            <div className="SourceTextIcon">
                                                                <Icon iconName="Documentation" />
                                                                <span>Sources:</span>
                                                            </div>
                                                            <a
                                                                href={msg?.SourceLink}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {msg?.Source}
                                                            </a>
                                                        </div>
                                                    )}
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '5px' }}>
                                                        <div
                                                            style={{
                                                                fontSize: "10px",
                                                                color: "#888",
                                                                textAlign: isUser ? "right" : "left",
                                                            }}
                                                        >
                                                            {timeFormatted}
                                                        </div>
                                                        <div className="LikeICON">
                                                            {msg?.Like?.includes(
                                                                CurrentUser?.loginName
                                                            ) ? (
                                                                <Icon
                                                                    title="Like"
                                                                    iconName="LikeSolid"
                                                                    className='LikeSoliIconColor'
                                                                    onClick={() =>
                                                                        LikeMessage("Like", index)
                                                                    }
                                                                />
                                                            ) : (
                                                                <Icon
                                                                    title="Like"
                                                                    iconName="Like"
                                                                    className="LikeIconColor"
                                                                    onClick={() =>
                                                                        LikeMessage("Like", index)
                                                                    }
                                                                />
                                                            )}
                                                            {msg?.Dislike?.includes(
                                                                CurrentUser?.loginName
                                                            ) ? (
                                                                <Icon
                                                                    title="Dislike"
                                                                    iconName="DislikeSolid"
                                                                    className='LikeSoliIconColor'
                                                                    onClick={() =>
                                                                        LikeMessage("Dislike", index)
                                                                    }
                                                                />
                                                            ) : (
                                                                <Icon
                                                                    title="Dislike"
                                                                    iconName="Dislike"
                                                                    className="LikeIconColor"
                                                                    onClick={() =>
                                                                        LikeMessage("Dislike", index)
                                                                    }
                                                                />
                                                            )}
                                                            <div style={{ fontSize: '10px', marginBottom: '2px' }}>|</div>
                                                            {copiedIndex === index ? (
                                                                <Icon
                                                                    iconName="CheckMark"
                                                                    className="LikeIconColor"
                                                                />
                                                            ) : (
                                                                <Icon
                                                                    title="Copy"
                                                                    iconName="Copy"
                                                                    onClick={() => copyToClipboard(msg?.text, index)}
                                                                    className="LikeIconColor"
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>}
                                                {isUser &&
                                                  Array.isArray(msg?.Attachments) &&
                                                    msg.Attachments.length > 0 && (
                                                        <div className="BotAttachedfile">
                                                            {msg.Attachments.map((attachment, i) => (
                                                                <div
                                                                    key={i}
                                                                    className="BotAttachedfileItem"
                                                                >
                                                                    <div className="SourceTextIcon">
                                                                        <Icon iconName="Documentation" />
                                                                    </div>
                                                                    {attachment.name || attachment}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                          </div>}
                        {isTyping && (
                            <div className='isTyping'>
                                <span>Rivo</span>
                                <div className={'bouncing-loader'}>
                                    <div style={{ backgroundColor: "rgba(0, 120, 212, 0.25)" }}></div>
                                    <div style={{ backgroundColor: "rgba(0, 120, 212, 0.25)" }}></div>
                                    <div style={{ backgroundColor: "rgba(0, 120, 212, 0.25)" }}></div>
                                </div></div>
                        )}
                        {/* {!loading && <div ref={messagesEndRef} />} */}
                        <div ref={messagesEndRef} />
                    </div>}
                </div>
            </div>
            {loading ? <Spinner label={`Please wait...${percent}%`} style={{ position: "absolute", top: "50%", width: "98%", display: "flex", justifyContent: "center" }} /> :
                <div className={showChat.Body ? "" : 'NewConversationWrapper'}>
                    {showChat.Body ?
                        <div className='inputField'>
                            {attachments.map((attachment, index) => (
                                <div key={index} className="AttachmentContainer" style={{ marginBottom: attachments.length > 1 ? '3px' : '0px' }}>
                                    <Icon
                                        iconName="TextDocument"
                                        styles={{ root: { fontSize: 11, margin: "2px 0px 2px 6px" } }}
                                    />
                                    <span className="AttachmetName">{attachment.name}</span>
                                    <IconButton
                                        title="Remove"
                                        iconProps={{ iconName: "Cancel" }}
                                        className="NewConversation"
                                        onClick={() => removeAttachment(index)}
                                        styles={{
                                            root: { height: 26, width: 26 },
                                            icon: { fontSize: 12 },
                                        }}
                                    />
                                </div>
                            ))}
                            <div className='attachmentCopilotSend'>
                                <IconButton
                                    title="Attach"
                                    iconProps={{
                                        iconName: "Attach",
                                        styles: { root: { color: "#0078d4", fontSize: "16px" } }
                                    }}
                                    style={{ width: "30px", height: "30px" }}
                                    onClick={() => document.getElementById("fileInput")?.click()}
                                />

                                <input
                                    type="text"
                                    placeholder="Ask copilot..."
                                    style={{ flex: 1, border: "none", fontSize: "10px", outline: "none" }}
                                    onKeyDown={(e) => {
                                        if (!isTyping && e.key === "Enter" && userInput.trim() !== "") {
                                            sendMessage();
                                        }
                                    }}
                                    value={userInput}
                                    onChange={(e) => setUserInput(e.target.value)}
                                />
                                <IconButton
                                    title="Send"
                                    iconProps={{ iconName: !isTyping ? "Send" : "StopSolid", styles: { root: { color: userInput?.length ? 'white !important' : '#bebaba !important', margin: !isTyping && '2px 4px 0px 8px', fontSize: isTyping ? '12px' : '14px' } } }}
                                    onClick={!isTyping ? () => sendMessage() : () => { }}
                                    className='SendButton'
                                />

                            </div>
                            <input
                                type="file"
                                id="fileInput"
                                multiple
                                style={{ display: "none" }}
                                onChange={(e) => {
                                    if (e.target.files?.length) {
                                        addAttachment(e.target.files);
                                    }
                                }}

                            />
                        </div> :
                        <div className={'NewConversationTextIcon'}
                            onClick={() => {
                                setMessages([]);
                                closeChat("NewConversation");
                            }}
                        >
                            <span>New Conversation</span>
                            <IconButton
                                aria-label="Send"
                                iconProps={{ iconName: "ChevronRightMed" }}
                                styles={{ icon: { fontSize: 10 } }}
                                className="NewConversation"
                            />
                        </div>}
                </div>}

        </div>
    );
};

export default CopilotChatbot;
